import React, { FC, useEffect } from 'react';

import { Box } from '@mui/material';
import { useRefinementList } from 'react-instantsearch';

import useTenantTranslation from '~/hooks/useTenantTranslation';
import CategoryNavigationLink from '~/pages/DiscoverPage/components/CategoryNavigationLink';
import { DISCOVER_EXPERTS_ROUTE } from '~/routes';

interface ExpertNavigationBlockProps {
  attribute: string;
  initialExpert?: string;
}

const ExpertNavigationBlock: FC<ExpertNavigationBlockProps> = ({ attribute, initialExpert }) => {
  const { t } = useTenantTranslation();

  const { refine } = useRefinementList({ attribute });

  useEffect(() => {
    if (refine && initialExpert) {
      refine(initialExpert);
    }
  }, [refine, initialExpert]);

  return (
    <Box>
      <CategoryNavigationLink data-testid="backToAllExpertsLink" to={DISCOVER_EXPERTS_ROUTE}>
        {t('page.discover.backToExperts')}
      </CategoryNavigationLink>
    </Box>
  );
};

export default ExpertNavigationBlock;
